import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Proofreading = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2a2 2 0 0 1 2-2h25a2 2 0 0 1 2 2v6a1 1 0 1 1-2 0V2H2v34h10a1 1 0 1 1 0 2H2a2 2 0 0 1-2-2V2Zm28 12.106a5.28 5.28 0 1 0 0 10.558 5.28 5.28 0 1 0 0-10.558Zm-7.388 5.279A7.386 7.386 0 0 1 28 12a7.386 7.386 0 0 1 7.388 7.385A7.386 7.386 0 0 1 28 26.77a7.386 7.386 0 0 1-7.388-7.385ZM28 30.592a7.888 7.888 0 0 0-7.893 7.89v2.892c0 .277.232.52.533.52h14.734c.289 0 .52-.23.52-.52v-2.892c0-4.36-3.532-7.89-7.894-7.89Zm-10 7.89c0-5.523 4.474-9.996 10-9.996s10 4.473 10 9.996v2.892A2.623 2.623 0 0 1 35.374 44H20.64C19.2 44 18 42.839 18 41.374v-2.892ZM7 7a1 1 0 0 0 0 2h13a1 1 0 1 0 0-2H7ZM6 18a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 9a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2H7Z"
  }));
});
Proofreading.displayName = 'Proofreading';
Proofreading.defaultProps = {
  'aria-label': 'Proofreading'
};
export default Proofreading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Proofreading.js
// module id = 3884
// module chunks = 11